module.exports = __webpack_public_path__ + "static/img/ry4.064e93f5.png";